import {
  SearchRuleItem,
  DetailOptionsType,
  ProcedureOptionsType,
  QuestionOptionsType,
  SectionOptionsType,
} from 'containers/AccountsList/AdvancedSearch/advancedSearchTypes';

export const searchItem: SearchRuleItem = {
  value: '',
  expression: 'Contains',
  operator: 'AND',
  regex: false,
  orderable: true,
};

export const sortItem = { sortKey: '', sortOrder: '' };

export const detailsColumnData = [
  'CID',
  'PID',
  'SID',
  'Name',
  'RelationshipManager',
  'Procedure',
  'SearchSnippet',
];

export const detailInitialState: DetailOptionsType = {
  questionDetails: true,
  fieldLabel: false,
  includeHidden: false,
};

export const procedureColumnData = [
  'Proteus Account ID',
  'CID',
  'PID',
  'SID',
  'Name',
  'RelationshipManager',
  'Procedure',
  'SearchSnippet',
];

export const procedureInitialSate: ProcedureOptionsType = {
  procedureText: true,
  isGlobal: false,
  procedureTitle: false,
  isInvisible: false,
  includeHidden: false,
};

export const questionColumnData = [
  'CID',
  'PID',
  'SID',
  'Name',
  'SectionTitle',
  'QuestionType,',
  'FieldName',
  'FieldLabel',
];

export const questionInitialState: QuestionOptionsType = {
  includeGlobal: true,
  includeInactive: false,
  includeHidden: false,
};

export const sectionColumnData = [
  'CID',
  'PID',
  'SID',
  'Name',
  'SectionTitle',
  'FormId',
  'FormNotes',
];

export const sectionInitialState: SectionOptionsType = {
  includeGlobal: true,
  includeInactive: false,
  includeHidden: false,
};
